// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--1jtf0","hint":"dd31006766--hint--3mDLB"};